export default "__VITE_ASSET__CR8k9Owv__"